// Mock data for Manatech Innovations website

export const companyInfo = {
  name: "Manatech Innovations Pvt. Ltd.",
  tagline: "High Quality Execution",
  description: "Delivering exceptional IT services and staffing solutions to drive your business forward.",
  location: "ENH-41, Ground Floor, Chicolna, Dabolim, 403804, Goa",
  email: "support@manatech.in",
  logo: "https://customer-assets.emergentagent.com/job_new-manatech/artifacts/d75jhfxt_image.png"
};

export const services = [
  {
    id: 1,
    title: "Contract Staffing",
    description: "Flexible staffing solutions to meet your project demands. Access skilled professionals for short-term and long-term contracts with seamless integration into your team.",
    icon: "Users",
    image: "https://images.pexels.com/photos/7580638/pexels-photo-7580638.jpeg?auto=compress&cs=tinysrgb&w=800"
  },
  {
    id: 2,
    title: "Permanent Staffing",
    description: "Find the right talent for permanent positions. Our comprehensive recruitment process ensures you get qualified candidates who align with your company culture and goals.",
    icon: "UserCheck",
    image: "https://images.unsplash.com/photo-1521791136064-7986c2920216?crop=entropy&cs=srgb&fm=jpg&q=85&w=800"
  },
  {
    id: 3,
    title: "SAP Services",
    description: "Expert SAP implementation, customization, and support services. Optimize your business processes with our certified SAP consultants and proven methodologies.",
    icon: "Database",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&q=85&w=800"
  },
  {
    id: 4,
    title: "Mobile & UI Applications",
    description: "Custom mobile and web application development with intuitive user interfaces. Transform your ideas into engaging digital experiences across all platforms.",
    icon: "Smartphone",
    image: "https://images.pexels.com/photos/5633334/pexels-photo-5633334.jpeg?auto=compress&cs=tinysrgb&w=800"
  },
  {
    id: 5,
    title: "Naval Architecture Engineering",
    description: "Comprehensive naval architecture and marine engineering solutions. From vessel design to structural analysis, we deliver innovative maritime solutions with precision.",
    icon: "Ship",
    image: "https://images.unsplash.com/photo-1605281317010-fe5ffe798166?crop=entropy&cs=srgb&fm=jpg&q=85&w=800"
  },
  {
    id: 6,
    title: "Real Estate Services",
    description: "End-to-end real estate solutions including property management, development consulting, and digital transformation for the real estate industry.",
    icon: "Building",
    image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?crop=entropy&cs=srgb&fm=jpg&q=85&w=800"
  }
];

export const stats = [
  { value: "20+", label: "Projects Delivered" },
  { value: "10+", label: "Happy Clients" },
  { value: "15+", label: "IT Professionals" },
  { value: "3+", label: "Years Experience" }
];

export const aboutContent = {
  title: "About Manatech Innovations",
  subtitle: "Your trusted partner in digital transformation and IT excellence.",
  paragraphs: [
    "Manatech Innovations Pvt. Ltd. is a leading Information Technology service company based in Goa, specializing in providing comprehensive IT solutions and staffing services to businesses across various industries.",
    "With our commitment to \"High Quality Execution,\" we deliver innovative technology solutions, expert staffing services, and cutting-edge mobile and web applications that drive business growth and digital transformation."
  ],
  mission: "To empower businesses through innovative IT solutions and exceptional talent acquisition.",
  vision: "To be the preferred IT partner for organizations seeking digital excellence and growth."
};

export const serviceOptions = [
  { value: "contract-staffing", label: "Contract Staffing" },
  { value: "permanent-staffing", label: "Permanent Staffing" },
  { value: "sap-services", label: "SAP Services" },
  { value: "mobile-ui", label: "Mobile and UI Application" },
  { value: "naval-architecture", label: "Naval Architecture Engineering" },
  { value: "real-estate", label: "Real Estate Services" }
];
